<template>
  <div>
    <b-navbar type="light" variant="light">
      <img src="../../assets/logo.png" height="30%" width="2%" />
      <span
        class="navbar-brand-full"
        style="font-size: 16px; font-weight: 500; color: black"
        >Save Trees</span
      >

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <AppHeaderDropdown right no-caret>
            <template slot="header">
              <div class="px-3">
                <img src="../../assets/user.png" class="img-avatar" />
              </div>
            </template>
            <template slot="dropdown">
              <b-dropdown-header tag="div" class="text-center">
                <strong>Settings</strong>
              </b-dropdown-header>
              <!-- <b-dropdown-item router-link to="/Profile">
            <i class="fa fa-user" /> Profile
          </b-dropdown-item> -->
              <!-- <b-dropdown-divider /> -->
              <b-dropdown-item @click="logout()">
                <i class="fa fa-lock" /> Logout
              </b-dropdown-item>
            </template>
          </AppHeaderDropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <div>
      <b-row class="justify-content-center mt-1 mr-1 ml-1">
        <b-col cols="12" xl="12">
          <transition name="slide">
            <b-card style="height: 144%">
              <div slot="header">
                <b-row class="justify-content-md-center">
                  <b-col cols="12" md="12" class="text-center">
                    <span>Hi! Welcome to the Save Trees admin panel.</span>
                    <br />
                    <span
                      >Please fill the information mentioned below and press
                      “Continue” to complete the admin registration
                      process.</span
                    >
                  </b-col>
                </b-row>
              </div>
              <b-container fluid>
                <b-row class="justify-content-md-center">
                  <b-col cols="12" md="10">
                    <b-row>
                     <b-col cols="12" md="6">
                    <b-row>
                      <b-col cols="12" md="5">
                        <span>Username *</span>
                      </b-col>
                      <b-col cols="12" md="7">
                        <div :class="{error: validation.hasError('username')}">
                          <b-form-group>
                            <b-form-input
                              v-model="username"
                              type="text"
                              id="username"
                              placeholder="Username"
                            ></b-form-input>
                            <template slot="description" v-if="validation.firstError('username')">
                              <span style="color:red;">{{validation.firstError('username')}}</span>
                            </template>
                          </b-form-group>
                        </div>
                      </b-col>

                      <!-- <b-col cols="12" md="5">
                        <span>Password *</span>
                      </b-col>
                      <b-col cols="12" md="7">
                        <div :class="{error: validation.hasError('password')}">
                          <b-form-group>
                            <b-form-input
                              v-model="password"
                              type="text"
                              id="password"
                              placeholder="Password"
                            ></b-form-input>
                            <template slot="description" v-if="validation.firstError('password')">
                              <span style="color:red;">{{validation.firstError('password')}}</span>
                            </template>
                          </b-form-group>
                        </div>
                      </b-col>

                      <b-col cols="12" md="5">
                        <span>Confirm Password *</span>
                      </b-col>
                      <b-col cols="12" md="7">
                        <div :class="{error: validation.hasError('confirmpassword')}">
                          <b-form-group>
                            <b-form-input
                              v-model="confirmpassword"
                              type="text"
                              id="confirmpassword"
                              placeholder="Confirm password"
                            ></b-form-input>
                            <template
                              slot="description"
                              v-if="validation.firstError('confirmpassword')"
                            >
                              <span style="color:red;">{{validation.firstError('confirmpassword')}}</span>
                            </template>
                          </b-form-group>
                        </div>
                      </b-col> -->

                      <b-col cols="12" md="5">
                        <span>Name *</span>
                      </b-col>
                      <b-col cols="12" md="7">
                        <div :class="{error: validation.hasError('name')}">
                          <b-form-group>
                            <b-form-input v-model="name" type="text" id="name" placeholder="Name"></b-form-input>
                            <template slot="description" v-if="validation.firstError('name')">
                              <span style="color:red;">{{validation.firstError('name')}}</span>
                            </template>
                          </b-form-group>
                        </div>
                      </b-col>

                      <b-col cols="12" md="5">
                        <span>Gender *</span>
                      </b-col>
                      <b-col cols="12" md="7">
                        <div :class="{error: validation.hasError('gender')}">
                          <b-form-group>
                            <!-- <b-form-input
                              v-model="gender"
                              type="text"
                              id="gender"
                              placeholder="Gender"
                            ></b-form-input> -->
                             <b-form-select v-model="gender" :options="options"></b-form-select>
                            <template slot="description" v-if="validation.firstError('gender')">
                              <span style="color:red;">{{validation.firstError('gender')}}</span>
                            </template>
                          </b-form-group>
                        </div>
                      </b-col>

                      <b-col cols="12" md="5">
                        <span>Email *</span>
                      </b-col>
                      <b-col cols="12" md="7">
                        <div :class="{error: validation.hasError('email')}">
                          <b-form-group>
                            <b-form-input
                              v-model="email"
                              type="text"
                              id="email"
                              placeholder="Email"
                            ></b-form-input>
                            <template slot="description" v-if="validation.firstError('email')">
                              <span style="color:red;">{{validation.firstError('email')}}</span>
                            </template>
                          </b-form-group>
                        </div>
                      </b-col>
                      <b-col cols="12" md="5">
                        <span>Phone Number *</span>
                      </b-col>
                       
                          <b-col cols="2">
                            <div
                              :class="{
                                error: validation.hasError('phonePrefix'),
                              }"
                            >
                              <b-form-group label="">
                                <b-form-input
                                  v-model="phonePrefix"
                                  type="text"
                                  id="prefix"
                                  placeholder="Prefix"
                                ></b-form-input>
                                <template
                                  slot="description"
                                  v-if="validation.firstError('phonePrefix')"
                                >
                                  <span style="color: red">{{
                                    validation.firstError("phonePrefix")
                                  }}</span>
                                </template>
                              </b-form-group>
                            </div>
                          </b-col>
                      <b-col cols="12" md="5">
                        <div :class="{error: validation.hasError('phone')}">
                          <b-form-group>
                            <b-form-input
                              v-model="phone"
                              type="text"
                              id="phone"
                              placeholder="Phone number"
                            ></b-form-input>
                            <template slot="description" v-if="validation.firstError('phone')">
                              <span style="color:red;">{{validation.firstError('phone')}}</span>
                            </template>
                          </b-form-group>
                        </div>
                      </b-col>

                      
                    </b-row>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-row>
                      
                      

                      <!-- <b-col cols="12" md="5" class="pt-3">
                        <span>Occupation</span>
                      </b-col>
                      <b-col cols="12" md="7" class="pt-3">
                        <div :class="{error: validation.hasError('occupation')}">
                          <b-form-group>
                            <b-form-input
                              v-model="occupation"
                              type="text"
                              id="occupation"
                              placeholder="Occupation"
                            ></b-form-input>
                            <template slot="description" v-if="validation.firstError('occupation')">
                              <span style="color:red;">{{validation.firstError('occupation')}}</span>
                            </template>
                          </b-form-group>
                        </div>
                      </b-col> -->

                      <b-col cols="12" md="5">
                        <span>Postal Address *</span>
                      </b-col>
                      <b-col cols="12" md="7">
                        <div :class="{error: validation.hasError('address')}">
                        <b-form-group>
                          <b-form-textarea
                            id="textarea"
                            v-model="address"
                            placeholder
                            rows="3"
                            max-rows="6"
                          ></b-form-textarea>
                          <template
                              slot="description"
                              v-if="validation.firstError('address')"
                            >
                              <span style="color:red;">{{validation.firstError('address')}}</span>
                            </template>
                        </b-form-group>
                        </div>
                      </b-col>
                      <b-col cols="12" md="5">
                        <span>Nationality *</span>
                      </b-col>
                      <b-col cols="12" md="7">
                        <div :class="{error: validation.hasError('nationality')}">
                          <b-form-group>
                            <b-form-input
                              v-model="nationality"
                              type="text"
                              id="nationality"
                              placeholder="Nationality"
                            ></b-form-input>
                            <template
                              slot="description"
                              v-if="validation.firstError('nationality')"
                            >
                              <span style="color:red;">{{validation.firstError('nationality')}}</span>
                            </template>
                          </b-form-group>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  
                    </b-row>
                  </b-col>
                </b-row>
              </b-container>
              <b-container fluid>
                <b-row class="justify-content-md-center">
                  <b-col cols="12" md="10">
                    <b-row>
                      <b-col cols="12" md="8">
                        <b-row>
                          <b-col cols="12" md="6">
                            <span>Role that have been assigned to you:</span>
                          </b-col>
                          <b-col cols="12" md="6">
                            <span><b>Super Admin</b></span>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12" md="12">
                        <b-row>
                          <b-col cols="12" md="4" class="pt-4">
                            <span>Rights that have been assigned to you:</span>
                          </b-col>
                          <b-col cols="12" md="4" class="pt-4">
                            <span>- Remove Post</span><br />
                            <span>- Remove Comment</span><br />
                            <span>- Ban User </span><br />
                            <span>- Add lower Admins</span><br />
                            <span>- Remove Country Admins </span><br />
                            <span class="px-2" style="font-size: 11px"
                              >Needs consensus of majority of super admins</span
                            ><br />
                          </b-col>
                          <b-col cols="12" md="4" class="pt-4">
                            <span>- View activity log of lower admins</span
                            ><br />
                            <span>- Revert actions of Country admins</span
                            ><br />
                            <span>- Revert actions of State admins</span><br />
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>

                    <b-row class="py-2 justify-content-md-center">
                      <span style="color: red">{{ msg }}</span>
                    </b-row>
                  </b-col>
                </b-row>
              </b-container>
              <template slot="footer">
                <b-row class="justify-content-md-center">
                  <b-button @click.prevent="inputCheck" size="sm"
                    >Continue</b-button
                  >
                </b-row>
              </template>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Header as AppHeader, SidebarToggler, AsideToggler } from "@coreui/vue";
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import store from "../../store";
export default {
  components: {
    AsideToggler,
    AppHeader,
    SidebarToggler,
    AppHeaderDropdown,
  },
  data: () => {
    return {
      incidents: [],
      email: null,
      name: null,
      gender: null,
      nationality: null,
      username: null,
      password: null,
      phonePrefix: null,
      phone: null,
      role: null,
      address: null,
      msg: null,
      appLoading: false,
      ServerError: false,
      totalIncidents: 0,
      userId:null,
       options: [
  
          { value: 'Male', text: 'Male' },
          { value: 'Female', text: 'Female' },
          
        ]
    };
  },
  validators: {
    email(value) {
      return this.Validator.value(value).required("Required Field").email();
    },
    name(value) {
      return this.Validator.value(value).required("Required Field");
    },
    gender(value) {
      return this.Validator.value(value).required("Required Field");
    },
    nationality(value) {
      return this.Validator.value(value).required("Required Field");
    },
    // phonePrefix(value) {
    //   return this.Validator.value(value).required("Required Field");
    // },
    phone(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[0-9]*$", "Please Input Valid Number.");
    },
    // password(value) {
    //   return this.Validator.value(value).required("Required Field");
    // },
    username(value) {
      return this.Validator.value(value).required("Required Field");
    },
    address(value) {
      return this.Validator.value(value).required("Required Field");
    },
  },
  beforeMount() {
    this.getProfile();
  },
  methods: {
    inputCheck() {
      this.msg = null;
      this.$validate().then((success) => {
       
        if (success) {
          
         this.addUser();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },

    addUser() {
      this.appLoading = true;
      var user = {};
      user["username"] = this.username;
      user["name"] = this.name;
      user["gender"] = this.gender;
      user["nationality"] = this.nationality;
      user["phonePrefix"] = this.phonePrefix;
      user["phone"] = this.phone;
      user["email"] = this.email;
      user["password"] = this.password;
      user["address"] = this.address;
      user["id"]= this.userId;
      var newURL = "/user/Edit";

      axios({
        method: "POST",
        url: newURL,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.push("/");
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },

    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.data.email) this.email = response.data.data.email;
          this.phone = response.data.data.phone;
          this.phonePrefix = response.data.data.phonePrefix;
          this.username = response.data.data.username;
          this.userId = response.data.data._id;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
     logout() {
      axios({
        method: "GET",
        url: "/user/logout",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      });
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      store.commit("logoutUser");
      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style scoped>
/* .ServerError {
  min-height: 100vh;
  min-width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999;
  background-color: white;
  overflow-x: hidden;
} */
</style>
